export const popoverContentStyles = {
	'&.MuiModal-root': {
		'.MuiDialog-container': {
			justifyContent: 'left',
			'.MuiPaper-root': {
				width: { md: '80%', xs: '100%' },
				marginLeft: 0,
				marginRight: { xs: '0px', md: '100px' },
				top: '3.8rem',
				maxHeight: 'calc(100% - 100px)',
				maxWidth: 'none',
			},
		},
	},
};

export const iconButtonStyles = {
	position: 'absolute',
	top: '0.75rem',
	right: '0.3rem',
	zIndex: '1',
	border: '1px solid #B9DEFA',
	marginRight: '34px',
	marginTop: '30px',
};
